import {
  getPhoneCountryByCode,
  type PhoneCountry,
} from '../constants/phone-country.constants';

export const convertToHalfWidth = (value: string): string => {
  return value.replace(/[０-９]/g, match => {
    return String.fromCharCode(match.charCodeAt(0) - 0xfee0);
  });
};

export const sanitizePhoneNumberInput = (
  value: string,
  maxLength: number
): string => {
  const numericOnly = value.replace(/[^0-9０-９]/g, '');
  return numericOnly.slice(0, maxLength);
};

export const formatPhoneNumberToE164 = (
  phone: string,
  country?: PhoneCountry
): string => {
  const digits = phone.replace(/\D/g, '');
  if (!digits || !country) {
    return '';
  }

  const dialDigits = country.dialCode.replace(/\D/g, '');

  if (digits.startsWith(dialDigits)) {
    return `+${digits}`;
  }

  let nationalNumber = digits;
  if (country.stripLeadingZero && nationalNumber.startsWith('0')) {
    nationalNumber = nationalNumber.slice(1);
  }

  return `+${dialDigits}${nationalNumber}`;
};

export const formatPhoneNumberByCountryCode = (
  phone: string,
  countryCode: string
): string => {
  return formatPhoneNumberToE164(phone, getPhoneCountryByCode(countryCode));
};
